import React from 'react';

const UnionPayCard = () => (
  <svg
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 0 29 19"
  >
    <defs>
      <path
        id="a"
        d="M26.58 19H2.42A2.4 2.4 0 0 1 0 16.62V2.38A2.4 2.4 0 0 1 2.42 0h24.16A2.4 2.4 0 0 1 29 2.38v14.25A2.4 2.4 0 0 1 26.58 19z"
      />
      <polygon id="c" points="0 0 16.925 0 16.925 23 0 23" />
      <polygon id="e" points=".752 0 17.98 0 17.98 23 .752 23" />
      <polygon id="g" points=".744 0 17.666 0 17.666 23 .744 23" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="b" fill="white">
        <use xlinkHref="#a" />
      </mask>
      <g mask="url(#b)">
        <g transform="translate(-4 -2)">
          <mask id="d" fill="white">
            <use xlinkHref="#c" />
          </mask>
          <path
            fill="#DD2423"
            d="M6.69 0h8.52c1.2 0 1.93 1.04 1.66 2.33L12.9 20.67c-.28 1.29-1.47 2.33-2.66 2.33H1.7C.52 23-.22 21.96.06 20.67L4.03 2.33C4.31 1.04 5.5 0 6.69 0"
            mask="url(#d)"
          />
          <g transform="translate(8.912)">
            <mask id="f" fill="white">
              <use xlinkHref="#e" />
            </mask>
            <path
              fill="#16315E"
              d="M7.44 0h9.8c1.19 0 .65 1.04.38 2.33l-3.97 18.34c-.28 1.29-.2 2.33-1.39 2.33h-9.8C1.27 23 .53 21.96.81 20.67L4.78 2.33C5.06 1.04 6.25 0 7.44 0"
              mask="url(#f)"
            />
          </g>
          <g transform="translate(19.334)">
            <mask id="h" fill="white">
              <use xlinkHref="#g" />
            </mask>
            <path
              fill="#036862"
              d="M7.43 0h8.53c1.19 0 1.93 1.04 1.65 2.33l-3.97 18.34c-.28 1.29-1.47 2.33-2.66 2.33H2.46C1.26 23 .52 21.96.8 20.67L4.77 2.33C5.05 1.04 6.24 0 7.43 0"
              mask="url(#h)"
            />
          </g>
          <g transform="translate(7 9)">
            <path
              fill="#FFFFFF"
              fillRule="nonzero"
              d="M3.33 0l-.5 2.26c-.11.43-.19.74-.45.93a.8.8 0 0 1-.51.17.5.5 0 0 1-.37-.1.45.45 0 0 1-.17-.33v-.1l.1-.58s.5-1.94.6-2.2V.02C1.04.03.86.02.85.01L.82.15.3 2.34l-.04.18-.09.61c0 .16.03.31.11.45.24.4.91.45 1.3.45.44.02.87-.08 1.26-.28.54-.3.69-.78.81-1.2l.06-.22.61-2.28.01-.03c-.33.02-.66.01-1-.01zm2.9 4.01c-.35 0-.47 0-.88.02L5.33 4l.11-.45.05-.2c.08-.32.15-.69.16-.8.01-.07.04-.24-.17-.24a.7.7 0 0 0-.26.08c-.05.17-.15.65-.2.86l-.15.73-.03.03c-.36 0-.49 0-.9.02l-.03-.04.2-.8a11 11 0 0 0 .27-1.4l.04-.01.94-.15.04.03-.07.24.22-.12c.18-.08.37-.13.57-.13.2-.02.4.08.49.26.08.2.03.43-.08.88l-.06.24-.2.95-.03.03zm1.43 0h-.48c-.13 0-.26 0-.46.02V4L6.7 4l.11-.33a7.48 7.48 0 0 0 .22-.93l.07-.42.02-.01.01-.02.49-.07c.13-.01.27-.04.5-.08v.04L8 2.64l-.11.48-.13.56-.06.3-.02.02-.02.01zM9.9 2.82c-.03.2-.1.38-.2.55a.34.34 0 0 1-.27.16c-.03 0-.2 0-.2-.24 0-.13.02-.26.05-.39.1-.38.2-.71.48-.71.22 0 .24.24.14.63zm.83-.86c-.18-.22-.5-.3-.84-.3a1.6 1.6 0 0 0-1.06.35c-.25.24-.4.54-.47.87-.08.32-.16.88.39 1.1.18.06.37.09.57.08.41.02.82-.13 1.12-.42.19-.23.32-.5.38-.78.13-.51.03-.76-.1-.9zm9.23-.27l-.98.15-.03.02-.01.1a.6.6 0 0 0-.3-.24c-.2-.07-.64.02-1.01.34-.25.24-.41.54-.47.87-.08.3-.16.87.38 1.08.15.06.32.09.49.08a.82.82 0 0 0 .46-.2l-.04.14.03.03c.4-.02.51-.02.94-.01l.04-.03c.06-.35.12-.69.28-1.35l.24-.95-.02-.03zm-1.73 1.88c-.03 0-.2 0-.2-.24 0-.13.02-.26.05-.38.1-.39.2-.71.48-.71.18 0 .27.16.25.42l-.05.21-.09.34a.8.8 0 0 1-.1.2.5.5 0 0 1-.34.16zm-5 .44c-.36 0-.48 0-.9.02V4l.1-.45.05-.2c.07-.27.12-.53.16-.8 0-.07.03-.24-.17-.24a.7.7 0 0 0-.26.08c-.05.17-.15.65-.2.86l-.15.73-.04.03c-.36 0-.48 0-.9.02l-.02-.04.2-.8c.12-.46.21-.93.27-1.4l.03-.01c.41-.06.51-.07.95-.15l.03.03-.06.24a1.44 1.44 0 0 1 .79-.25c.2-.02.4.08.5.26.07.2.02.42-.1.88l-.05.24c-.12.5-.13.6-.2.95l-.04.03zm3.04-4h-.3L14.8 0l-.03.15-.28 1.2-.68 2.67h1.05l.18-.83.14-.54a.32.32 0 0 1 .08-.07h.07c.57 0 1.21 0 1.72-.36a1.74 1.74 0 0 0 .73-1.4.73.73 0 0 0-.13-.46C17.38 0 16.86 0 16.27 0zm-.1 1.84c-.2.09-.44.12-.67.1h-.15V1.9l.3-1.19V.59l.12.01.62.05c.23.09.33.31.26.6a.88.88 0 0 1-.48.6zm-8.05-.37a.83.83 0 0 0-.78.08c-.24.15-.27.37-.07.48.26.1.55.07.78-.08.23-.16.26-.37.07-.48zm14.77.2l-.03-.03c-.44.08-.52.1-.92.14l-.03.03v.02c-.3.65-.29.5-.53 1.02V2.8l-.06-1.12-.04-.03c-.46.08-.47.1-.89.14l-.03.03v.05l.09.6.08.6.11.98c-.28.45-.34.62-.62 1.01l-.19.29a.14.14 0 0 1-.07.06.3.3 0 0 1-.12.02h-.11l-.16.5h.54c.26.02.5-.11.63-.33l.34-.56 2-3.36z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default UnionPayCard;
